import React from 'react'
import PropTypes from 'prop-types'

export default function MultipleDrop({ value }) {
  try {
    const formattedValue = JSON.parse(value)
    return formattedValue.join(' | ')
  } catch (e) {
    return value
  }
}

MultipleDrop.propTypes = {
  value: PropTypes.string
}

MultipleDrop.defaultProps = {
  value: null
}
